import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/feedbacksActions';
import ServerError from '../ServerError';
import Loading from '../Loading';
import config from 'react-global-configuration';

export class Authenticate extends React.Component {
  constructor(props) {
    super(props);
    if (props.isUnauthorized) {
      window.location.href = config.get('login');
    } else {
      window.location.href = '/';
    }

  }

  render() {

    if (this.props.error) {
      return (<ServerError error={this.props.error} />);
    }
    return (
      <main role="main" className="container-fluid">
        <Loading/>
      </main>
    );
  }
}


Authenticate.propTypes = {
  actions: PropTypes.object.isRequired,
  error: PropTypes.string,
  isUnauthorized: PropTypes.bool,
};

function mapStateToProps() {
  const myUrlWithParams = new URL(window.location.href);
  const token = myUrlWithParams.searchParams.get('token');
  let isUnauthorized = false;

  if (token) {
    localStorage.setItem('QUSER', token);
    localStorage.setItem('GDPR', true);
  } else {
    isUnauthorized = true;
  }

  return {
    isUnauthorized,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Authenticate);
